/**
 * /tenants/$slug/authentication/sign-in/methods — how people can sign in.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";
import { applicationAccessSearchSchema } from "@/features/ciam-applications/schemas";
import { tenantCapabilities } from "@/features/tenants/capabilities";
import { signInSectionPresent } from "@/features/signin-settings/sections";
import { MethodsSection } from "@/features/signin-settings/pages/methods-section";

export const Route = createFileRoute("/_authed/tenants/$slug/authentication/sign-in/methods")({
  // The consumer population card pages its applications through the URL.
  validateSearch: applicationAccessSearchSchema.parse,
  beforeLoad: ({ context, params }) => {
    const tenant = context.settingsTenant;
    if (!signInSectionPresent("methods", tenant, tenantCapabilities(tenant))) {
      throw redirect({ to: "/tenants/$slug/authentication/sign-in", params: { slug: params.slug } });
    }
  },
  component: MethodsSection,
});
